import React, { useState, useRef, useEffect } from 'react';
import io from 'socket.io-client';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import LoadingChat from './LoadingChat';
import { useLoaderData } from 'react-router';
import gavi from './gavi.svg';

const TypingText = ({ text, speed = 30, isLastMessage = true,color }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!isLastMessage && currentIndex < text.length) {
      setDisplayedText(text);
      setCurrentIndex(text.length);
    }
  }, [isLastMessage, text, currentIndex]);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    }
  }, [currentIndex, text, speed]);

  useEffect(() => {
    setDisplayedText('');
    setCurrentIndex(0);
  }, [text]);

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ node, children, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer" style={{ color: color}}>{children}</a>
        )
      }}
    >
      {displayedText}
    </ReactMarkdown>
  );
};

const ChatbotWidget = () => {
  // const id = window.location.pathname.split('/')[2];

  const { id, o } = useLoaderData();
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [welcomeMessage, setWelcomeMessage] = useState('');
  const [color, setColor] = useState('');
  const [token, setToken] = useState('');
  const [enabledWelcomeMessage, setEnabledWelcomeMessage] = useState(false);
  const socketRef = useRef(null);
  const [faqSuggestions, setFaqSuggestions] = useState([]);
  const [isLargeFontSize, setIsLargeFontSize] = useState(false);
  const contentClickHandlerRef = useRef(null);
  const shouldAutoScrollRef = useRef(true);


  const defaultStyles = {
    backgroundColor: '#FFFFFF',
    topBarColor: '#06262D',
    userBubbleColor: '#D41367',
    userTextColor: '#FFFFFF',
    botBubbleColor: '#F2F4F4',
    botTextColor: '#27283B',
    buttonColor: '#D41367',
    fontSize: isLargeFontSize ? '20px' : '16px',
    lineHeight: isLargeFontSize ? '28px' : '24px',
    inputFontSize: isLargeFontSize ? '18px' : '14px'
  }

  // preRenderedQuestions removido: se reemplaza por preguntas dinámicas desde la API

  const handleMessage = (e => {
    console.log('handleMessage chatbotwidget', e)
    //setColor(e.data.color);
  });


  // Carga inicial del widget (id estable al montar). Dependencias intencionalmente omitidas.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getChatbotInfo();
    let sessionMessages = JSON.parse(sessionStorage.getItem(`messages-${id}`));
    if (sessionMessages !== undefined && sessionMessages !== null && sessionMessages.length > 0) setMessages(sessionMessages);
    if (window) {
      window.onmessage = handleMessage;
    }
    if (!socketRef.current) setupSocketConnection();
    return () => {
      console.log("Desmontando componente, cerrando conexión ...");

      if (socketRef.current) {
        socketRef.current.disconnect();
        console.log("desconectado correctamente.");
      }

      if (window) {
        window.onmessage = null;
      }
    };
  }, []);
//SIMON REVISA ESTO
  useEffect(() => {
    const content = document.getElementById('content')
    if (shouldAutoScrollRef.current && content) {
      content.scrollTop = content.scrollHeight;
    }
    sessionStorage.setItem(`messages-${id}`, JSON.stringify(messages));
  }, [messages, id])
  useEffect(() => {
    if (!token) {
      return;
    }

    const content = document.getElementById('content');
    if (!content) {
      return;
    }

    const handleClick = (event) => {
      const link = event.target.closest('a[href]');
      if (!link || !content.contains(link)) {
        return;
      }

      const messageElement = link.closest('[data-message-id]');
      if (!messageElement) {
        return;
      }

      const payload = { link_url: link.getAttribute('href') };
      if (messageElement.dataset.chatbotHistoryId) {
        payload.chatbot_history_id = messageElement.dataset.chatbotHistoryId;
      }

      fetch(`${process.env.REACT_APP_GLOBOT_URL}/bot/${token}/track-click`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch((error) => {
        console.error('Error registrando click de link:', error);
      });
    };

    content.addEventListener('click', handleClick, true);
    contentClickHandlerRef.current = handleClick;

    return () => {
      if (contentClickHandlerRef.current) {
        content.removeEventListener('click', contentClickHandlerRef.current, true);
        contentClickHandlerRef.current = null;
      }
    };
  }, [token]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (messages.length === 0 && welcomeMessage !== undefined && welcomeMessage !== null && welcomeMessage.length > 0 && enabledWelcomeMessage) {
      setMessages([
        {
          id: Date.now(),
          text: welcomeMessage,
          sender: 'bot',
          likes: 0,
          dislikes: 0,
          feedbackGiven: false
        }
      ]);
    }
  }, [welcomeMessage, enabledWelcomeMessage, messages]);

  const getChatbotInfo = async () => {
    const response = await fetch(`${process.env.REACT_APP_GLOBOT_URL}/bot/${id}/info`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('API request failed');
    }
    const data = await response.json();
    setName(data.name);
    nameRef.current = data.name
    setWelcomeMessage(data.welcome_message);
    setEnabledWelcomeMessage(data.enabled_welcome_message);

    if (undefined !== data.chatbot_widget_configuration?.configuration?.color
      && null !== data.chatbot_widget_configuration?.configuration?.color) {
      // setColor(data.chatbot_widget_configuration.configuration.color);
      try {
        window.parent.postMessage({ color: data.chatbot_widget_configuration.configuration.color }, '*');
      } catch (e) { }
    } else {
      // setColor(defaultStyles.userBubbleColor);
      try {
        window.parent.postMessage({ color: defaultStyles.userBubbleColor }, '*');
      } catch (e) { }
    }

    setToken(data.token);

    // Construir mensajes iniciales: bienvenida (si no hay historial)
    const initialMessages = [];
    if (data.enabled_welcome_message && data.welcome_message) {
      initialMessages.push({
        id: Date.now(),
        text: data.welcome_message,
        sender: 'bot',
        likes: 0,
        dislikes: 0,
        feedbackGiven: false
      });
    }

    // Guardar FAQs como sugerencias clicables, ordenadas por order_position (1=abajo, 10=arriba)
    if (Array.isArray(data.faqs) && data.faqs.length > 0) {
      setFaqSuggestions(
        data.faqs
          .filter(f => f && f.question)
          .sort((a, b) => (b.order_position || 0) - (a.order_position || 0))
      );
    } else {
      setFaqSuggestions([]);
    }

    if (initialMessages.length > 0) {
      setMessages(prev => (prev && prev.length > 0) ? prev : initialMessages);
    }
  }

  const nameRef = useRef('Chatbot');

  const setupSocketConnection = () => {
    // Obtener correlation-id de sessionStorage
    const correlationId = sessionStorage.getItem('correlation-id');

    if (correlationId && id) {
      // Crear nombre de room
      const roomName = `${id}-${correlationId}`;

      // Configurar conexión de socket

      socketRef.current = io(`${process.env.REACT_APP_SOCKET_URL}`, {
        path: '/ws/socket.io', // Asegúrate de que coincida con el servidor
        reconnection: true,
      });

      // Conectarse a la room
      socketRef.current.on('connect', () => {

        socketRef.current.emit('join', { room: roomName }); // Emite el evento 'join'

      });



      // Escuchar mensajes
      socketRef.current.on('new_message_answer', (msg) => {

        setMessages(prevMessages => [
          ...prevMessages,
          { id: Date.now(), text: msg, sender: 'bot', likes: 0, dislikes: 0, feedbackGiven: false }
        ]);

      });

      // Escuchar mensajes
      socketRef.current.on('take_control', (user) => {
        console.log('Control changed to:', user, 'Current bot name:', nameRef.current);

        if (user === undefined) {
          // Si el control vuelve a la IA, usar el nombre del ref
          const botName = nameRef.current || 'Chatbot';
          console.log('Returning control to bot:', botName);

          setMessages(prevMessages => [
            ...prevMessages,
            {
              id: Date.now(),
              text: `Volviste a hablar con ${botName}`,
              sender: 'system',
              isControlMessage: true,
              controlName: botName, // Almacenar el nombre para facilitar el estilo
              controlType: 'bot'    // Tipo de control para diferentes estilos
            }
          ]);
          // controlador restablecido (estado eliminado por no uso)
        } else {
          // Control tomado por un agente humano
          console.log('Human agent took control:', user);

          setMessages(prevMessages => [
            ...prevMessages,
            {
              id: Date.now(),
              text: `Ahora hablas con ${user}`,
              sender: 'system',
              isControlMessage: true,
              controlName: user,     // Almacenar el nombre para facilitar el estilo
              controlType: 'human'   // Tipo de control para diferentes estilos
            }
          ]);
          // controlador humano (estado eliminado por no uso)
        }
      });


      // Manejar errores de conexión
      socketRef.current.on('connect_error', (err) => {
        console.error('Error al conectar:', err);
      });



    }
  };

  const handleSend = async (text, file = null, faqId = null) => {
    if (text.length < 1) return
    const newMessage = { id: Date.now(), text, sender: 'user', file };
    setMessages(prevMessages => [...prevMessages, newMessage]);
    setInput('');
    setIsLoading(true);

    try {

      let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };

      if (sessionStorage.getItem('correlation-id') !== undefined && sessionStorage.getItem('correlation-id') !== null) {
        headers['correlation-id'] = sessionStorage.getItem('correlation-id')
      }

      if (o) {
        headers['GLOBOTORIGIN'] = o;
      }

      // Preparar body con o sin faq_id
      const body = { prompt: text };
      if (faqId) {
        body.faq_id = faqId;
      }

      const response = await fetch(`${process.env.REACT_APP_GLOBOT_URL}/bot/${token}/prompt`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        console.log("TUVE UN ERROR")
        const errorData = await response.json();

        if (response.status === 400 && errorData.code === 6) {
          const message = `Superaste el límite de ${errorData.limit} mensajes de tu plan actual. Suscríbete para realizar más consultas.`
          setMessages(prevMessages => [
            ...prevMessages,
            {
              id: Date.now(),
              text: message,
              sender: 'bot',
              likes: 0,
              dislikes: 0,
              feedbackGiven: false,
              showButton: true,
              showWarning: true,
              button: {
                title: 'Suscríbete',
                onpress: () => window.open('https://globot.netlify.app/precios/', '_blank')
              }
            }
          ]);
          return;
        } else {
          throw new Error(`API request failed: ${errorData.message || 'Unknown error'}`);
        }
      }

      const responseHeaders = response.headers;

      if (responseHeaders.get("correlation-id") !== null) {
        sessionStorage.setItem("correlation-id", responseHeaders.get("correlation-id"));
      }
      if (!socketRef.current) {
        setupSocketConnection();
      }
      const data = await response.json();
      const botResponse = data.response || "Tengo problemas para responder en este momento, por favor intenta nuevamente.";

      if (data.response !== '') {
        const botMessage = {
          id: Date.now(),
          text: botResponse,
          sender: 'bot',
          likes: 0,
          dislikes: 0,
          feedbackGiven: false
        };
        // Agregar chatbot_history_id si viene en la respuesta
        if (data.chatbot_history_id) {
          botMessage.chatbotHistoryId = data.chatbot_history_id;
        }
        setMessages(prevMessages => [
          ...prevMessages,
          botMessage
        ]);
      }
    } catch (error) {
      console.error('Error fetching bot response:', error);

      setMessages(prevMessages => [
        ...prevMessages,
        { id: Date.now(), text: "Tengo problemas para responder en este momento, por favor intenta nuevamente.", sender: 'bot', likes: 0, dislikes: 0, feedbackGiven: false }
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleQuestionClick = (faq) => {
    handleSend(faq.question, null, faq.id);
  };

  // Subida de archivos y eliminación de mensajes no utilizados actualmente
  const handleClearHistory = () => {
    setMessages(prevMessages => {
      if (isChatActive(prevMessages)) {
        return [prevMessages[0]];
      } else {
        return [];
      }
    });
    sessionStorage.removeItem(`messages-${id}`);
  }

  const toggleFontSize = () => {
    setIsLargeFontSize(!isLargeFontSize);
  }

  const isChatActive = (prevMessages) => {
    return (enabledWelcomeMessage && prevMessages.length > 0 && prevMessages[0].text === welcomeMessage)
  }

  const handleCloseChat = () => {
    try {
      window.parent.postMessage({ action: 'toggleChat' }, '*');
    } catch (e) {
      console.error('Error al cerrar el chat:', e);
    }
  }

  // Like/Dislike no utilizado actualmente

  const handleFeedback = async (chatbotHistoryId, feedback) => {
    /**
     * Envía feedback sobre una respuesta del chatbot al backend.
     * @param {string} chatbotHistoryId - ID del chatbot_history a valorar
     * @param {boolean|null} feedback - true=positivo, false=negativo, null=sin feedback
     */
    if (!chatbotHistoryId) {
      console.warn('No se puede enviar feedback: chatbot_history_id no disponible');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_GLOBOT_URL}/bot/${token}/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          chatbot_history_id: chatbotHistoryId,
          feedback: feedback
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error al enviar feedback:', errorData);
        throw new Error(errorData.error || 'Error al enviar feedback');
      }

      const data = await response.json();
      console.log('Feedback enviado exitosamente:', data);
      return data;
    } catch (error) {
      console.error('Error en handleFeedback:', error);
      throw error;
    }
  };

  const handleLikeDislike = async (chatbotHistoryId, type, messageId) => {
    /**
     * Maneja el click en los botones de like/dislike
     * @param {string} chatbotHistoryId - ID del chatbot_history
     * @param {string} type - 'like' o 'dislike'
     * @param {number} messageId - ID local del mensaje en el estado
     */
    try {
      // Determinar el valor del feedback: true para like, false para dislike
      // Si ya tiene ese feedback, lo quitamos (null)
      const currentFeedback = messages.find(m => m.id === messageId)?.feedbackGiven;
      let feedbackValue;

      if (currentFeedback === type) {
        // Si ya tiene este feedback, lo quitamos
        feedbackValue = null;
      } else {
        // Si no tiene feedback o tiene el otro, asignamos el nuevo
        feedbackValue = type === 'like' ? true : false;
      }

      await handleFeedback(chatbotHistoryId, feedbackValue);

      // Deshabilitar auto-scroll temporalmente para preservar posición
      shouldAutoScrollRef.current = false;

      // Actualizar el estado local del mensaje
      setMessages(prevMessages =>
        prevMessages.map(msg =>
          msg.id === messageId
            ? { ...msg, feedbackGiven: feedbackValue === null ? null : type }
            : msg
        )
      );

      // Reactivar auto-scroll después del siguiente render
      setTimeout(() => {
        shouldAutoScrollRef.current = true;
      }, 100);
    } catch (error) {
      console.error('Error al procesar feedback:', error);
    }
  };

  const renderMessage = (message) => {
    const isUser = message.sender === 'user';
    const isBot = message.sender === 'bot';
    const isSystem = message.sender === 'system';

    if (isSystem && message.isControlMessage) {
      let preText = '';
      let controlName = '';
      let emoji = '';

      // Determinar el prefijo según el tipo de control
      if (message.controlType === 'human') {
        preText = 'Ahora hablas con un ';
        controlName = 'agente en línea';
        emoji = '👋';
      } else if (message.controlType === 'bot') {
        preText = 'Ahora hablas con el ';
        controlName = 'asistente virtual';
        emoji = '🤖';
      }
      return (
        <div key={message.id} className="flex justify-center my-4 relative ">
          <div className="absolute left-0 right-0 top-1/2 transform -translate-y-1/2">
            <hr className="w-full border-t border-gray-300" />
          </div>
          <div className="text-center text-gray-500 text-sm relative z-10 bg-white px-3">
            <span>{preText}</span>
            <span className="font-bold" style={{ color: '#64748B' }}>{controlName}</span>
            <span> {emoji}</span>
          </div>
        </div>
      );
    }

    const bubbleProps = (!isUser && isBot) ? {
      'data-message-id': message.id,
      ...(message.chatbotHistoryId ? { 'data-chatbot-history-id': message.chatbotHistoryId } : {})
    } : {};

    return (
      <div key={message.id} className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4 group `}>

        <div className="rounded-xl relative p-[14px] bold font-medium " style={{ maxWidth: isLargeFontSize ? '100%' : '90%', background: isUser ? color ? color : defaultStyles.userBubbleColor : defaultStyles.botBubbleColor, color: isUser ? defaultStyles.userTextColor : defaultStyles.botTextColor, fontSize: defaultStyles.fontSize, lineHeight: defaultStyles.lineHeight, transition: 'all 0.5s ease' }} {...bubbleProps}>

          <div className='flex row' style={{ flexDirection: isUser ? 'column' : (message.showButton) ? 'row' : 'column' }}>
            {!isUser && message.showWarning && (
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="24" viewBox="0 0 30 30" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-yellow-500 mr-2 ml-2" >
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            )
            }

            {!isUser && messages.length > 0 && message.id === messages[messages.length - 1].id ? (
              <TypingText text={message.text} speed={18} isLastMessage={message.id === messages[messages.length - 1].id} color={defaultStyles.buttonColor} />
            ) : (
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  a: ({ node, children, ...props }) => (
                    <a {...props} target="_blank" rel="noopener noreferrer " style={{ color: defaultStyles.buttonColor }}>{children}</a>
                  )
                }}
              >
                {message.text}
              </ReactMarkdown>
            )}

            {message.file && message.file.type.startsWith('image/') && (
              <div className="mt-2 max-w-full overflow-hidden">
                <img
                  src={URL.createObjectURL(message.file)}
                  alt="Uploaded"
                  className="w-full h-auto max-h-[100px] object-cover rounded cursor-pointer"
                  onClick={() => window.open(URL.createObjectURL(message.file), '_blank')}
                />
              </div>
            )}
            {message.file && !message.file.type.startsWith('image/') && (
              <div className="mt-2 flex items-center text-blue-500">
                <span className="mr-2">📎</span>
                <span >{message.file.name}</span>
              </div>
            )}
          </div>

          {message.showButton && (
            <button
              onClick={message.button.onpress}
              style={{ background: color ? color : defaultStyles.userBubbleColor }}
              className="mt-2 ml-8 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
            >
              {message.button.title}
            </button>
          )}
          {/* Botones de feedback para mensajes del bot */}
          {!isUser && message.chatbotHistoryId && (
            <div className="mt-2 flex items-center space-x-2">
              <button
                onClick={() => handleLikeDislike(message.chatbotHistoryId, 'like', message.id)}
                className={`transition-opacity ${message.feedbackGiven === 'like' ? 'opacity-100' : 'opacity-50 hover:opacity-100'}`}
                title="Me gusta"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill={message.feedbackGiven === 'like' ? '#64748B' : 'none'} stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M7 10v12" /><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                </svg>
              </button>
              <button
                onClick={() => handleLikeDislike(message.chatbotHistoryId, 'dislike', message.id)}
                className={`transition-opacity ${message.feedbackGiven === 'dislike' ? 'opacity-100' : 'opacity-50 hover:opacity-100'}`}
                title="No me gusta"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill={message.feedbackGiven === 'dislike' ? '#64748B' : 'none'} stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 14V2" /><path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
                </svg>
              </button>
            </div>
          )}
        </div>


      </div>
    );
  };

  return (
    <div className="flex flex-col h-full w-full border border-gray-300 rounded-2xl overflow-hidden" style={{ background: defaultStyles.backgroundColor, fontSize: '14px' }}>
      {/* header */}
      <div className="text-white py-3.5 px-4.5 flex items-center" style={{ background: color ? color : defaultStyles.topBarColor }}>
        <img src={gavi} alt="Gavi" className="w-14 h-14" />

        <span className='mr-auto ml-3.5 text-2xl font-semibold'>{name}</span>

        <div className="flex items-center gap-3">

          <button onClick={toggleFontSize}
            className="text-sm text-white py-2 px-1 rounded hover:scale-150  transition-all" title='cambiar tamaño de fuente'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="active:scale-110 transition-all">
              <path d={!isLargeFontSize ? "M3.5 13H9.5M2 16L6.5 7L11 16M18 16V7M18 7L14 11M18 7L22 11" : "M3.5 13H9.5M2 16L6.5 7L11 16M18 7V16M18 16L14 12M18 16L22 12"} stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <button onClick={handleClearHistory}
            className="text-sm text-white py-2 px-1 rounded transition-transform duration-500 delay-100 hover:rotate-360" title='Reiniciar conversación'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.516 3.00947 16.931 3.99122 18.74 5.74L21 8M21 8V3M21 8H16M21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.48395 20.9905 7.06897 20.0088 5.26 18.26L3 16M3 16H8M3 16V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <button onClick={handleCloseChat}
            className="text-sm text-white py-2 px-1 rounded hover:scale-150  transition-all" title='Cerrar chat'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>

        </div>
      </div>
      {/* content */}
      <div id="content" className="flex-1 overflow-y-auto p-4 flex flex-col" >
        <div className="space-y-4">
          {messages.length === 0 ? (
            <>
              {/* MENSAJE SUPERIOR */}
              {/* <div className="text-center text-gray-500 mb-4">
                {welcomeMessage}
              </div> */}
            </>
          ) : (
            // typeof messages.map === 'function' ? messages.map(renderMessage) : null
            messages.map(renderMessage)
          )}
          {isLoading && (
            <div className={`flex 'justify-start' mb-4 group`}>
              <div className="p-2 rounded-lg relative" style={{ maxWidth: isLargeFontSize ? '100%' : '90%', background: defaultStyles.botBubbleColor, color: defaultStyles.botTextColor, fontSize: defaultStyles.fontSize, lineHeight: defaultStyles.lineHeight, transition: 'all 0.5s ease' }}>
                <LoadingChat></LoadingChat>
              </div>
            </div>
          )}

        </div>
        {/* Chips de FAQs dentro del área de scroll, pegados al fondo */}
        {faqSuggestions && faqSuggestions.length > 0 && messages.length <= 1 && (
          <div className="mt-auto pt-4">
            <div className="flex flex-col items-end gap-2">
              {faqSuggestions.map((faq, index) => (
                <button
                  key={index}
                  onClick={() => handleQuestionClick(faq)}
                  className=" transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-md"
                  style={{
                    maxWidth: isLargeFontSize ? '100%' : '90%',
                    fontSize: defaultStyles.fontSize,
                    lineHeight: defaultStyles.lineHeight,
                    transition: 'all 0.5s ease',
                    borderRadius: '12px',
                    border: '1px solid #06262D',
                    textAlign: 'right',
                    padding: '8px 12px',
                    backgroundColor: 'transparent',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'scale(1.01)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'scale(1)';
                  }}
                >
                  {faq.question}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
      {/* footer */}
      <div className="border-t border-gray-300 p-4 bg-white">
        <div className="flex items-center gap-[10px]">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSend(input)}
            placeholder="Escribe un mensaje..."
            className={`flex-1 border border-[#697C81] rounded-sm p-2 focus:outline-none focus:border-[${color ? color : defaultStyles.buttonColor}]`}
            style={{ fontSize: defaultStyles.inputFontSize, transition: 'all 0.5s ease' }}
          />
          {/* <button
            onClick={() => fileInputRef.current.click()}
            className="bg-gray-100 text-gray-600 p-2 hover:bg-gray-200 focus:outline-none"
          >
            📎
          </button>
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileUpload}
            className="hidden"
            accept="image/*,.pdf,.doc,.docx,.txt"
          /> */}
          <button
            onClick={() => handleSend(input)}
            className="text-white p-2 rounded-sm hover:scale-105 transition-all focus:outline-none"
            style={{ background: color ? color : defaultStyles.buttonColor }}
            disabled={isLoading}
            title="Enviar">

            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M22.0003 12C22.0003 12.0948 21.9734 12.1875 21.9227 12.2675C21.872 12.3476 21.7996 12.4115 21.714 12.452L3.71402 20.952C3.62412 20.9956 3.52318 21.0112 3.42434 20.9966C3.32549 20.9821 3.2333 20.9381 3.15974 20.8705C3.08619 20.8029 3.03468 20.7147 3.0119 20.6174C2.98913 20.5202 2.99614 20.4183 3.03202 20.325L5.87402 12.698C6.0417 12.2478 6.0417 11.7523 5.87402 11.302L3.03102 3.67504C2.99495 3.58168 2.98785 3.47962 3.01064 3.38216C3.03343 3.28471 3.08505 3.19638 3.15878 3.1287C3.23251 3.06102 3.32492 3.01712 3.42396 3.00273C3.523 2.98834 3.62409 3.00413 3.71402 3.04804L21.714 11.548C21.7996 11.5885 21.872 11.6525 21.9227 11.7325C21.9734 11.8126 22.0003 11.9053 22.0003 12ZM22.0003 12L6 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

          </button>
        </div>
      </div>
      <div className="text-center text-gray-500 mb-4" style={{ fontSize: '12px' }}>
        Creado por <a href="https://globot.ai/?utm_source=website_munivina&utm_medium=web&utm_campaign=main" target="_blank" rel="noreferrer" style={{ color: color ? color : defaultStyles.buttonColor, textDecoration: 'underline' }} title='Ir a globot.ai'>Globot.ai</a>
      </div>
    </div>
  );
};

export default ChatbotWidget;